



















import Vue from "vue";
import { mapState } from "vuex";
import { Stepper } from "@canvas/vuejsonschemaform";

export default Vue.extend({
  components: {
    Stepper,
  },
  data(): { [key: string]: any } {
    return {
      currentStep: 0,
      stepMap: {
        create: 0,
        details: 1,
        assign: 2,
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      designerDetails: "assignedDesigner",
    }),
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
    steps(): Array<{ title: string; stepNumber: number; status: string }> {
      const getStatusForStep = (step: number, currentStep: number): string => {
        const self = this as any;
        if (currentStep === step) {
          return "process";
        } else if (currentStep < step) {
          return "wait";
        } else {
          return "finish";
        }
      };
      return [
        {
          title: "Basic Details",
          stepNumber: 0,
          status: getStatusForStep(0, (this as any).currentStep),
        },
        {
          title: "Project Details",
          stepNumber: 1,
          status: getStatusForStep(1, (this as any).currentStep),
        },
        {
          title: "Project Assignment",
          stepNumber: 2,
          status: getStatusForStep(2, (this as any).currentStep),
        },
      ];
    },
  },
  mounted() {
    if ((this as any).$route.name) {
      (this as any).currentStep = (this as any).stepMap[
        (this as any).$route.name
      ];
    } else {
      (this as any).currentStep = 0;
    }
  },
  watch: {
    $route(newVal, oldVal) {
      (this as any).currentStep = (this as any).stepMap[newVal.name];
    },
    designerDetails(newVal, oldVal) {
      if (newVal) {
        (this as any).currentStep++;
      }
    },
  },
});
